<template>
  <v-card>
    <v-layout fill-height column justify-space-between wrap class="ma-0">
      <v-flex shrink class="pa-0">
        <v-card-title primary-title class="title">{{ title }}</v-card-title>
      </v-flex>
      <v-flex shrink class="pa-0">
        <v-card-text class="text-xs-right headline primary--text">
          <template v-if="loading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </template>
          <template v-else>
            {{ value }}
          </template>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/ReplyComment/StatCounter.vue